import axios from 'axios';
import Cookies from 'js-cookie';
import { Message } from '../../components';
import { jwtDecode } from 'jwt-decode';

const apiSetting = async ({ method, url, headers, data = null }) => {
  try {
    // if (!url || typeof url !== 'string' || !url.startsWith('http')) {
    //   throw new Error('Invalid URL');
    // }
    // 從 Cookie 取得 token，防呆檢查
    const token = Cookies.get('employeeToken');
    let decoded = {};
    if (token && typeof token === 'string') {
      try {
        decoded = jwtDecode(token);
      } catch (e) {
        // token 格式錯誤，視為未登入
        decoded = {};
      }
    }

    const config = {
      method: method,
      url: url,
      headers: headers ? { ...headers } : {},
    };
    if (token) {
      config.headers['X-User-Name'] = decoded.id;
      config.headers.Authorization = `Bearer ${token}`; // 加上 JWT
    }

    if (data != null) {
      config.data = data;
    }
    // console.log(config);
    const response = await axios(config);
    return response;
  } catch (error) {
    if (error.status === 500) {
      Message(`伺服器錯誤 -> ${error}`, 'error');
    } else {
      console.log(error)
    }
    // throw error;
    return;
  }
};

export default apiSetting;
